module.exports = __webpack_public_path__ + "static/8-5e109e42355793f70f0e53b38c0ce573.jpg";